import moment from "moment"

export default function humanReadableTimeAgo(objectId: string): string {
	const commentDate = new Date(parseInt(objectId.substring(0, 8), 16) * 1000)
	let string = moment(commentDate).fromNow()
	if (string === "a few seconds ago") string = "just now"
	string = string.replace("minutes", "min")
	return string
}
